module.exports = __webpack_public_path__ + "img/hero-lg.51e10ddf.png";